import { Controller } from "@hotwired/stimulus"
import DataTable from 'datatables.net-bs5'

import 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.print'
import 'pdfmake/build/pdfmake'
import 'pdfmake/build/vfs_fonts'
import JSZip from 'jszip'

window.JSZip = JSZip

// Connects to data-controller="admin--bookings"
export default class extends Controller {
  connect() {
    if (this.element.dataset.datatableInitialized === "true") return

    if ($(this.element).hasClass('dataTable')) return

    this.table = new DataTable(this.element, {
      paging: true,
      serverSide: true,
      processing: true,
      ajax: {
        url: "/admin/bookings/paginate",
        data: function (d) {
          const urlParams = new URLSearchParams(window.location.search)
          d.start_date = urlParams.get("start_date")
          d.end_date = urlParams.get("end_date")
          d.status = urlParams.get("status")
        }
      },
      dom: '<"html5buttons"B>lTfgitp',
      responsive: true,
      retrieve: true,
      lengthChange: false,
      pageLength: 20,
      columnDefs: [ { type: 'date', 'targets': [3] } ],
      language: {
        url: "/datatables/pt-BR.json"
      },
      order: [[0, 'desc']],
      buttons: [
        {
          text: 'CSV',
          className: 'btn btn-outline-primary',
          action: function () {
            const params = new URLSearchParams(window.location.search).toString()
            window.open(`/admin/bookings/export.csv?${params}`, '_blank')
          }
        },
        {
          text: 'Excel',
          className: 'btn btn-outline-success',
          action: function () {
            const params = new URLSearchParams(window.location.search).toString()
            window.open(`/admin/bookings/export.xlsx?${params}`, '_blank')
          }
        },
        {
          extend: 'pdf',
          text: 'PDF',
          filename: 'relatorio-agendamentos',
          exportOptions: {
            modifier: { page: 'all' },
            columns: ':visible:not(.no-export)'
          }
        },
        {
          extend: 'print',
          text: 'Imprimir',
          exportOptions: {
            modifier: { page: 'all' },
            columns: ':visible:not(.no-export)'
          },
          customize: function (win) {
            $(win.document.body).addClass('white-bg')
            $(win.document.body).css('font-size', '10px')
            $(win.document.body).find('table').addClass('compact').css('font-size', 'inherit')
          }
        }
      ]
    })

    this.element.dataset.datatableInitialized = true
  }
}
